import { SEASONAL_OCCASIONS } from '../data/seasonalOccasions';

/**
 * Returns seasonal occasions that are currently active for the given country.
 *
 * @param {string|null} countryCode - ISO 3166-1 alpha-2 code (e.g., 'US'), or null
 * @param {Date} [now=new Date()] - Current date (injectable for testing)
 * @returns {Array} Active seasonal occasions sorted by priority (ascending)
 */
export function getActiveSeasonalOccasions(countryCode = null, now = new Date()) {
  const currentMonth = now.getMonth() + 1; // JS months are 0-indexed
  const currentDay = now.getDate();

  return SEASONAL_OCCASIONS
    .filter(event => {
      // Country check: null means worldwide, otherwise must match
      if (event.countries !== null) {
        if (!countryCode || !event.countries.includes(countryCode)) {
          return false;
        }
      }

      // Date window check
      return isDateInRange(currentMonth, currentDay, event);
    })
    .sort((a, b) => a.priority - b.priority);
}

/**
 * Check if a month/day falls within an event's date range.
 * Handles year-wrapping (e.g., startMonth=11, endMonth=1).
 */
function isDateInRange(month, day, event) {
  const { startMonth, startDay, endMonth, endDay } = event;

  const current = month * 100 + day;
  const start = startMonth * 100 + startDay;
  const end = endMonth * 100 + endDay;

  if (start <= end) {
    // Normal range (e.g., Jan 14 - Feb 14)
    return current >= start && current <= end;
  } else {
    // Year-wrapping range (e.g., Nov 15 - Jan 5)
    return current >= start || current <= end;
  }
}
